import api from '..'

export class OrganizationService {
  static async findAllSfds() {
    const response = await api.get(
      '/organizations?type=sfd&select=-kkiapayAccounts&populate=admin'
    )
    return response.data.map((org: { _id: string }) => ({
      ...org,
      id: org._id
    }))
  }

  static async findAll(sfds: string[]) {
    const response = await api.get(
      '/organizations?type=sfd&select=-kkiapayAccounts&populate=admin'
    )
    const orgs = response.data
      .filter((org: { _id: string }) => sfds.includes(org._id))
      .map((org: { _id: string }) => ({ ...org, id: org._id }))
    console.log({ orgs, response, sfds })
    return orgs
  }
}
